import { axiosGateway } from "@/services/axiosTools";
import Cookie from "js-cookie"

// 获取写作promt列表
export function getPromptList() {
    return axiosGateway.get(
      {
        url: `/cloud-browser-aigc/rest/aiwriting/v1/release`,
        gatewayKey: 'baseURL2',
      })
  }

export function getPromptListV2() {
  return axiosGateway.get(
    {
      url: `/cloud-browser-aigc/rest/aiwriting/v2/release`,
      gatewayKey: 'baseURL2',
    })
}

// 提交分享数据
export function submitShareData(data) {
  return axiosGateway.post(
    {
      url: `/cloud-browser-aigc/api/aiwriting/v1/share/exchange`,
      gatewayKey: 'baseURL2',
      headers: {
        authorization: Cookie.get('slbrowser_pc_ai_assist_authorization'),
        timeout: 1000 * 120,
      },
      data,
    })
}

// 获取分享数据
export function getShareData(params) {
  return axiosGateway.get(
    {
      url: `/cloud-browser-aigc/rest/aiwriting/v1/share/query`,
      gatewayKey: 'baseURL2',
      headers: {
        authorization: Cookie.get('slbrowser_pc_ai_assist_authorization'),
        timeout: 1000 * 120,
      },
      params,
    })
}